// https://react-icons.github.io/react-icons
import React from 'react';
import { FiArrowLeft, FiX } from "react-icons/fi";

export const FeatierArrowLeft:React.FC = () => <FiArrowLeft />;
export const FeatherCross: React.FC = () => <FiX />